<div class="card checkout-shipping-form shadow-none border-0 shadow-none">
  <div class="card-body">
    <div class="edit-profile__body">
      <ng-container *ngIf="!showSignatureComponent; else signature">
        <form #personalForm="ngForm" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="firstName">
                  <!-- First Name -->
                  {{ "personalInfo.firstName" | translate }}
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="firstName"
                  [(ngModel)]="personalInfo.first_name"
                  name="firstName"
                  required
                  [placeholder]="
                    'personalInfo.firstNamePlaceholder' | translate
                  "
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="lastName">
                  <!-- Last Name -->
                  {{ "personalInfo.lastName" | translate }}
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="lastName"
                  [(ngModel)]="personalInfo.last_name"
                  name="lastName"
                  required
                  [placeholder]="'personalInfo.lastNamePlaceholder' | translate"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="country">
                  <!-- Country -->
                  {{ "personalInfo.country" | translate }}
                </label>
                <select
                  id="country"
                  [(ngModel)]="personalInfo.country"
                  name="country"
                  class="dropdown form-control"
                  required
                  (ngModelChange)="onCountryChange()"
                >
                  <option
                    *ngFor="let country of countries"
                    [value]="country.countryName"
                  >
                    <!-- {{ country.countryName }} -->
                    {{ "countries." + country.countryShortCode | translate }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="state">
                  <!-- State/Region -->
                  {{ "personalInfo.state" | translate }}
                </label>
                <select
                  id="state"
                  [(ngModel)]="personalInfo.state_region"
                  name="state"
                  class="dropdown form-control"
                  [disabled]="!selectedCountryRegions.length"
                >
                  <option value="">
                    <!-- Select a region -->
                    {{ "personalInfo.selectRegion" | translate }}
                  </option>
                  <option
                    *ngFor="let region of selectedCountryRegions"
                    [value]="region.name"
                  >
                    <!-- {{ region.name }} -->
                    {{
                      "regions." + currentCountryCode + "." + region.name
                        | translate
                    }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="email">
                  <!-- Email Address -->
                  {{ "personalInfo.email" | translate }}
                </label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  [(ngModel)]="personalInfo.email"
                  (input)="onEmailChange($event)"
                  (keydown)="onEmailChange($event)"
                  (paste)="onEmailChange($event)"
                  name="email"
                  required
                  email
                  [placeholder]="'personalInfo.EmailPlaceholder' | translate"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="phone">
                  <!-- Phone Number -->
                  {{ "personalInfo.phone" | translate }}
                </label>
                <div class="phone-wrapper">
                  <span *ngIf="phoneStartWith !== 0" class="input-group-text">
                    + {{ phoneStartWith }}
                  </span>
                  <input
                    type="tel"
                    class="form-control"
                    id="phone"
                    [style.padding-left]="phoneStartWith == 0 ? '20px' : '54px'"
                    [style.padding-right]="'35px'"
                    [(ngModel)]="maskedPhone"
                    (input)="onPhoneInput($event)"
                    (keydown)="onPhoneKeyDown($event)"
                    (paste)="onPhonePaste($event)"
                    name="phone"
                    required
                    [placeholder]="'personalInfo.PhonePlaceholder' | translate"
                    autocomplete="new-password"
                  />
                  <span class="eye" (click)="toggleShowPhone()">
                    <i *ngIf="phoneIsHidden" class="fas fa-eye-slash"></i>
                    <i *ngIf="!phoneIsHidden" class="fas fa-eye"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="error_message && !isOpenModal" class="alert alert-danger">
            {{ error_message }}
          </div>
          <div class="text-center">
            <button
              type="submit"
              class="btn btn-primary btn-default btn-squared text-capitalize text-white"
              [disabled]="
                !personalForm.valid ||
                !isStateRegionValid() ||
                personalInfo.phone === ''
              "
            >
              <!-- Save & Next -->
              {{ "personalInfo.saveNext" | translate }}
              <i class="ms-10 me-0 las la-arrow-right"></i>
            </button>
          </div>
        </form>
        <div
          *ngIf="isOpenModal"
          class="modal-basic modal fade show"
          id="modal-basic"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-md" role="document">
            <div class="modal-dialog modal-md" role="document">
              <div class="modal-content modal-bg-white">
                <div class="modal-header">
                  <h6 class="modal-title">
                    <!-- Verify Your Email -->
                    {{ "personalInfo.verifyEmail" | translate }}
                  </h6>
                </div>
                <!-- <div class="modal-body text-center">
                  <p>
                    We've sent a 6-digit verification code to your email address
                    <br />
                    <b>Adrian@gmail.com</b>
                    <br />
                    Please enter the code below to continue.
                  </p>

                  <div class="d-flex justify-content-center gap-2 my-3">
                    <input type="text" class="code-input" maxlength="1" />
                    <input type="text" class="code-input" maxlength="1" />
                    <input type="text" class="code-input" maxlength="1" />
                    <input type="text" class="code-input" maxlength="1" />
                    <input type="text" class="code-input" maxlength="1" />
                    <input type="text" class="code-input" maxlength="1" />
                  </div>

                  <p>
                    Didn’t receive the code? Check your spam folder or try
                    resending.
                  </p>
                  <a href=""> Send code again </a>
                </div> -->
                <div class="card-body">
                  <div class="edit-profile__body">
                    <div>
                      <p class="text-center">
                        <!-- We've sent a 6-digit verification code to your email
                        address -->
                        {{ "personalInfo.codeSent" | translate }}
                      </p>
                      <p class="text-center">
                        <b>{{ personalInfo.email }}</b>
                      </p>
                      <p class="text-center">
                        <!-- Please enter the code below to continue -->
                        {{ "personalInfo.enterCode" | translate }}
                      </p>
                    </div>
                    <div>
                      <div>
                        <div class="code-container">
                          <input
                            #codeOne
                            class="code-input"
                            type="text"
                            [(ngModel)]="CodeData.one"
                            name="one"
                            maxlength="6"
                            inputmode="numeric"
                            required
                            (input)="onCodeInput($event, 'one')"
                            (keydown)="onCodeKeydown($event, 'one')"
                            (keydown.enter)="isCodeValid() && verify()"
                          />
                          <input
                            #codeTwo
                            class="code-input"
                            type="text"
                            [(ngModel)]="CodeData.two"
                            name="two"
                            maxlength="1"
                            inputmode="numeric"
                            required
                            (input)="onCodeInput($event, 'two')"
                            (keydown)="onCodeKeydown($event, 'two')"
                            (keydown.enter)="isCodeValid() && verify()"
                          />
                          <input
                            #codeThree
                            class="code-input"
                            type="text"
                            [(ngModel)]="CodeData.three"
                            name="three"
                            maxlength="1"
                            inputmode="numeric"
                            required
                            (input)="onCodeInput($event, 'three')"
                            (keydown)="onCodeKeydown($event, 'three')"
                            (keydown.enter)="isCodeValid() && verify()"
                          />
                          <input
                            #codeFour
                            class="code-input"
                            type="text"
                            [(ngModel)]="CodeData.four"
                            name="four"
                            maxlength="1"
                            inputmode="numeric"
                            required
                            (input)="onCodeInput($event, 'four')"
                            (keydown)="onCodeKeydown($event, 'four')"
                            (keydown.enter)="isCodeValid() && verify()"
                          />
                          <input
                            #codeFive
                            class="code-input"
                            type="text"
                            [(ngModel)]="CodeData.five"
                            name="five"
                            maxlength="1"
                            inputmode="numeric"
                            required
                            (input)="onCodeInput($event, 'five')"
                            (keydown)="onCodeKeydown($event, 'five')"
                            (keydown.enter)="isCodeValid() && verify()"
                          />
                          <input
                            #codeSix
                            class="code-input"
                            type="text"
                            [(ngModel)]="CodeData.six"
                            name="six"
                            maxlength="1"
                            inputmode="numeric"
                            required
                            (input)="onCodeInput($event, 'six')"
                            (keydown)="onCodeKeydown($event, 'six')"
                            (keydown.enter)="isCodeValid() && verify()"
                          />
                        </div>
                        <br />
                      </div>
                    </div>
                    <div>
                      <p class="text-center">
                        <!-- Didn't receive the code? Check your spam folder or try
                        resending. -->
                        {{ "personalInfo.noCode" | translate }}
                      </p>
                    </div>
                    <div *ngIf="error_message" class="alert alert-danger">
                      {{ error_message }}
                    </div>
                    <div class="send-code-container">
                      <span
                        *ngIf="isSendCodeDisabled && isSendedCode"
                        class="timer"
                      >
                        {{ countdown }}
                      </span>
                      <button
                        *ngIf="isSendedCode"
                        [disabled]="isSendCodeDisabled"
                        (click)="sendCodeOnEmail()"
                        class="send-code-again link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
                        style="margin: 0 !important"
                        [ngStyle]="{
                          color: isSendCodeDisabled ? 'gray' : '#8231D3'
                        }"
                      >
                        <!-- Send code again -->
                        {{ "personalInfo.sendAgain" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    (click)="verify()"
                    [disabled]="!isCodeValid()"
                  >
                    <!-- Verify -->
                    {{ "personalInfo.verify" | translate }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    data-bs-dismiss="modal"
                    (click)="closeModal()"
                  >
                    <!-- Cancel -->
                    {{ "personalInfo.cancel" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #signature>
        <app-agreement-signature
          [personalInfo]="personalInfo"
          (submit)="onSignatureSubmit()"
          (rerender)="onRerender()"
        ></app-agreement-signature>
      </ng-template>
    </div>
  </div>
</div>
